import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonBreadcrumb } from './Breadcrumb.definition';
import { chameleonBreadcrumbItem } from './BreadcrumbItem/BreadcrumbItem.definition';
import { chameleonMenu } from '../Menu/Menu.definition';
import { chameleonPopover } from '../Popover/Popover.definition';
provideChameleonDesignSystem().register(chameleonBreadcrumb(), chameleonBreadcrumbItem(), chameleonMenu(), chameleonPopover());
